var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/fn/object/create.js
// module id = 249
// module chunks = 0